import AjaxUtils from "../util/ajax_utils";

const finalise_login = function (resp, xhr) {
    const redirect = resp.redirect || "/spa/";
    window.location.replace(redirect);
}

export const route_with_params = function(route) {
    return {
        name: route,
        query: Object.fromEntries(new URLSearchParams(document.location.search))
    }
}

export const ApckLoginForm = {
    data: function() {
        return {
            username: "",
            password: "",
            accept_terms: false,
            password_step: false,
        };
    },
    props: {
        url: String,
        termsAccepted: Boolean,
        errors: {
            type: Object,
            default: {}
        },
    },
    mounted() {
        const cmp = this;
        this.$data.accept_terms = this.$props.termsAccepted;

        AjaxUtils.ajax_get({
            url: this.url,
            success: (json)=> {
                if (json.saml_result) {
                    cmp.$flash({
                        'type': json.saml_result.type,
                        'message': json.saml_result.message
                    });
                }
                if (json.redirect === 'next') {
                    // The user is already logged in
                    window.location.replace(json.next)
                }
            }
        })
    },
    methods: {
        username_updated: function () {
            const _last_username = this.last_username;
            this.last_username = this.username;

            if (this.password_step) {
                if (_last_username === this.username) {
                    return;
                }

                this.password_step = false;
                this.password = "";
                this.$emit('update:errors', {});
            }
        },
        submit_form: function (data, success_cb) {
            const cmp = this;
            cmp.$emit('update:errors', {});

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(data),
                success: success_cb,
                fail: function (json) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {});

                    if (json.message) {
                        cmp.$flash({
                            type: 'error',
                            message: json.message
                        });
                    }

                    if (json?.redirect === 'login') {
                        cmp.$router.push(route_with_params('security.login'));
                    } else if (json?.redirect === 'mfa_setup') {
                        cmp.$router.push(route_with_params('security.mfa.setup'));
                    } else if (json?.redirect === 'mfa_auth') {
                        cmp.$router.push(route_with_params('security.mfa.auth'));
                    }
                }
            })
        },
        submit_username: function () {
            const cmp = this;
            const data = {
                username: cmp.username,
                accept_terms: cmp.accept_terms,
            }

            this.submit_form(data, function (json, status, xhr) {
                if (json.sso_redirect) {
                    window.location.href = json.sso_redirect;
                } else {
                    cmp.password_step = true;
                    cmp.$nextTick(() => {
                        cmp.$refs.password_field.focusField();
                    });
                }
            });
        },
        submit_password: function () {
            const cmp = this;
            const data = {
                username: cmp.username,
                password: cmp.password,
                accept_terms: cmp.accept_terms,
            }

            this.submit_form(data, function (json, status, xhr) {
                if (json.redirect === 'next') {
                    // The user is already logged in, so don't perform finalise_login()
                    window.location.replace(json.next);
                } else {
                    finalise_login(json, xhr);
                }
            });
        },
        login: function () {
            if (this.password_step) {
                this.submit_password();
            } else {
                this.submit_username();
            }
        },
        forgotPassword: function () {
            this.$router.push(route_with_params('security.forgot-password'));
        }
    },
    template: `
        <div class="auth">
            <div class="form">
                <h1>AppCheck Login</h1>
                
                <form class="inner" @submit.prevent="login">
                    <input type="submit" hidden />
                    
                    <apck-field :errors="errors?.username">
                        <apck-text
                            v-model="username"
                            label="Email"
                            @input="username_updated()"
                        />
                    </apck-field>
                    
                    <apck-field :errors="errors?.password" v-show="password_step">
                        <apck-password
                            v-model="password"
                            label="Password"
                            ref="password_field"
                        />
                    </apck-field>

                    <apck-field :errors="errors?.accept_terms" v-show="!password_step">
                        <apck-checkbox
                            v-model="accept_terms"
                            label="Agree to Terms and Conditions"
                        />
                    </apck-field>

                    <div class="actions">
                        <apck-button
                            title="Login"
                            value="Login"
                            class="btn-primary"
                            :handler="login"
                        />
                        <apck-button
                            title="Forgot password?"
                            value="Forgot password?"
                            class="btn-secondary"
                            :handler="forgotPassword"
                        />
                    </div>                      
                </form>
                
                <div class="links">
                    <a href="/assets/acceptable_use_policy.pdf"
                       class="terms"
                       target="_blank"
                       rel="noopener noreferrer"
                    >Terms and Conditions</a>
                </div>
            </div>
        </div>
    `
}

export const ApckForgotPassword = {
    data: function() {
        return {
            email: "",
        };
    },
    props: {
        url: String,
        errors: {
            type: Object,
            default: {}
        },
    },
    methods: {
        login: function () {
            this.$router.push(route_with_params('security.login'));
        },
        submit: function() {
            var cmp = this;

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(this.$data),
                success: function () {
                    // redirect to login
                    cmp.login();
                },
                fail: function (json) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {})
                }
            });
        },
    },
    template: `
        <div class="auth">
            <div class="form">
                <h1>Forgot Your Password?</h1>
                
                <form class="inner" @submit.prevent="submit">
                    <input type="submit" hidden />
                    
                    <apck-field :errors="errors?.email">
                        <apck-text
                            v-model="email"
                            label="Email"
                        />
                    </apck-field>

                    <div class="actions">
                        <apck-button
                            title="Send Password Reset"
                            value="Send Password Reset"
                            icon="fa-envelope"
                            class="btn-primary"
                            :handler="submit"
                        />
                        <apck-button
                            title="Return to login"
                            value="Return to login"
                            icon="fa-arrow-left"
                            class="btn-secondary"
                            :handler="login"
                        />
                    </div>                      
                </form>
                
                <div class="links"></div>
            </div>
        </div>
    `
}

export const ApckPasswordReset = {
    data: function() {
        return {
            password: "",
            password_confirm: "",
        };
    },
    props: {
        url: String,
        errors: {
            type: Object,
            default: {}
        },
        new_user: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        submit: function() {
            var cmp = this;

            // check password confirmation matches
            if (this.$data.password !== this.$data.password_confirm) {
                cmp.$emit('update:errors', {password_confirm: ["Passwords do not match"]})
                return;
            }
            const form_data = {
                password: cmp.$data.password
            }

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(form_data),
                success: function (json, status, xhr) {
                    finalise_login(json, xhr);
                },
                fail: function (json) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {})

                    if (json.message) {
                        cmp.$flash({
                            type: 'error',
                            message: json.message
                        });
                    }

                    if (json?.redirect === 'login') {
                        cmp.$router.replace({name: 'security.login'});
                    } else if (json?.redirect === 'mfa_setup') {
                        cmp.$router.replace({name: 'security.mfa.setup'});
                    } else if (json?.redirect === 'mfa_auth') {
                        cmp.$router.replace({name: 'security.mfa.auth'});
                    }
                }
            });
        },
    },
    template: `
        <div class="auth">
            <div class="form">
                <h1 v-if="new_user">Activate Your Account</h1>
                <h1 v-else>Reset Your Password</h1>
                
                <form class="inner" @submit.prevent="submit">
                    <input type="submit" hidden />
                    
                    <apck-field :errors="errors?.password">
                        <apck-password
                            v-model="password"
                            label="Password"
                        />
                        <small>(Minimum of 8 characters with at least 1 uppercase letter 1 symbol and 1 number)</small>
                    </apck-field>
                    
                    <apck-field :errors="errors?.password_confirm">
                        <apck-password
                            v-model="password_confirm"
                            label="Confirm Password"
                        />
                    </apck-field>

                    <div class="actions">
                        <apck-button
                            :title="new_user ? 'Activate Account' : 'Reset Password'"
                            :value="new_user ? 'Activate Account' : 'Reset Password'"
                            class="btn-primary"
                            :handler="submit"
                        />
                    </div>                      
                </form>
                
                <div class="links"></div>
            </div>
        </div>
    `
}

export const ApckMfaReset = {
    data: function() {
        return {
            password: "",
        };
    },
    props: {
        url: String,
        errors: {
            type: Object,
            default: {}
        },
    },
    methods: {
        submit: function() {
            var cmp = this;

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(this.$data),
                success: function () {
                    cmp.$router.push(route_with_params('security.mfa.setup'));
                },
                fail: function (json) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {})

                    if (json?.redirect === 'login') {
                        cmp.$router.push(route_with_params('security.login'));
                    }
                },
                opts: {redirect_on_401: false}
            });
        },
    },
    template: `
        <div class="auth">
            <div class="form">
                <h1>Re-set up Multifactor Authentication</h1>
                
                <form class="inner" @submit.prevent="submit">
                    <input type="submit" hidden />
                    
                    <apck-field :errors="errors?.password">
                        <apck-password
                            v-model="password"
                            label="Password"
                        />
                    </apck-field>

                    <div class="actions">
                        <apck-button
                            title="Authenticate"
                            value="Authenticate"
                            class="btn-primary"
                            :handler="submit"
                        />
                    </div>                      
                </form>
                
                <div class="links"></div>
            </div>
        </div>
    `
}

export const ApckMfaSetup = {
    data: function() {
        return {
            otp: "",
        };
    },
    props: {
        url: String,
        qr_code: {
            type: String,
            default: null
        },
        otp_seed: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default: {}
        },
    },
    methods: {
        submit: function() {
            var cmp = this;

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(this.$data),
                success: function (json, status, xhr) {
                    if (json.redirect === 'next') {
                        // The user is already logged in, so don't perform finalise_login()
                        window.location.replace(json.next);
                    } else {
                        finalise_login(json, xhr);
                    }
                },
                fail: function (json) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {})

                    if (json?.redirect === 'mfa_reset') {
                        cmp.$router.replace(route_with_params('security.mfa.reset'));
                    } else if (json?.redirect === 'login') {
                        cmp.$router.replace(route_with_params('security.login'));
                    }
                },
                opts: {redirect_on_401: false}
            });
        },
    },
    template: `
        <div class="auth">
            <div class="form">
                <h1>Set up Authenticator</h1>
                
                <ol>
                    <li>
                        Download an OTP authenticator app, such as Google Authenticator:
                        <ul>
                            <li>Android: <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">Google Play</a></li>
                            <li>iPhone: <a href="https://apps.apple.com/gb/app/google-authenticator/id388497605">App Store</a></li>
                        </ul>
                    </li>
                    <li>
                        Add the secret key to the authenticator app:
                        <ul>
                            <li>
                                Scan the QR code
                                <img :src="qr_code">
                            </li>
                            <li>OR, enter the key <strong>{{ otp_seed }}</strong> and select "time based" as the method for this account.</li>
                        </ul>
                    </li>
                    <li>
                        Enter the 6-digit code from your authenticator app:
                        <form class="no-padding" @submit.prevent="submit">
                            <input type="submit" hidden/>

                            <apck-field :errors="errors?.otp">
                                <apck-totp-field
                                    v-model="otp"
                                    label="Verification code"
                                />
                            </apck-field>

                            <div class="actions">
                                <apck-button
                                    title="Verify"
                                    value="Verify"
                                    class="btn-primary"
                                    :handler="submit"
                                />
                            </div>
                        </form>
                    </li>
                </ol>
                
                <div class="links"></div>
            </div>
        </div>
    `
}

export const ApckMfaAuth = {
    data: function() {
        return {
            otp: "",
        };
    },
    props: {
        url: String,
        errors: {
            type: Object,
            default: {}
        },
    },
    methods: {
        submit: function() {
            var cmp = this;

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(this.$data),
                success: function (json, status, xhr) {
                    if (json.redirect === 'next') {
                        // The user is already logged in, so don't perform finalise_login()
                        window.location.replace(json.next);
                    } else {
                        finalise_login(json, xhr);
                    }
                },
                fail: function (json) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {})

                    if (json?.redirect === 'login') {
                        cmp.$router.replace(route_with_params('security.login'));
                    }
                },
                opts: {redirect_on_401: false}
            });
        },
    },
    template: `
        <div class="auth">
            <div class="form">
                <h1>TOTP 2-step Authentication</h1>
                
                    <p>Enter the 6-digit code from your authenticator app.</p>
                    <br>
                
                    <form class="inner" @submit.prevent="submit">
                        <input type="submit" hidden/>

                        <apck-field :errors="errors?.otp">
                            <apck-totp-field
                                v-model="otp"
                                label="Verification code"
                            />
                        </apck-field>

                        <div class="actions">
                            <apck-button
                                title="Verify"
                                value="Verify"
                                class="btn-primary"
                                :handler="submit"
                            />
                        </div>
                    </form>
                
                <div class="links"></div>
            </div>
        </div>
    `
}

export const ApckImpersonationBanner = {
    props: {
        url: String,
        message: String,
        prompt: String,
    },
    methods: {
        close () {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        }
    },
    template: `
        <div id="impersonationPrompt" class="lightbox">
            <div class="lightbox-shadow"></div>
            <div class="lightbox-outer">
                <span class="lightbox-close" @click="close">
                    <i class="icon fa-close"></i>
                </span>
                <div class="title-bar">
                    <!--  <span class="title-text"></span>  -->
                </div>
                <div class="lightbox-inner">
                    <div>
                        <br/>
                        <p>{{ message }}</p>
                        <br/>
                        <a :href="url" class="btn btn-negative">{{ prompt }}</a>
                    </div>
                </div>
            </div>
        </div>
    `
}